import { Link } from "react-router-dom";

export default function BSSBottomCTA() {
  return (
    <section className="py-20 px-8 md:px-16 bg-[#2C2825]">
      <div className="max-w-screen-xl mx-auto flex flex-col md:flex-row items-center justify-between gap-10">
        <div className="max-w-xl">
          <p
            className="text-[#B5A898] text-[10px] tracking-[0.45em] uppercase mb-4"
            style={{ fontFamily: "'Inter', sans-serif" }}
          >
            Calm Spaces Journal
          </p>
          <h2
            className="text-[#FAF7F0] text-2xl md:text-3xl leading-snug mb-4"
            style={{ fontFamily: "'Playfair Display', serif", fontWeight: 400 }}
          >
            More guides for calm, considered living
          </h2>
          <p
            className="text-[#8B8378] text-sm leading-relaxed"
            style={{ fontFamily: "'Inter', sans-serif", fontWeight: 300 }}
          >
            Explore our full collection of interior guides — from soft beige living rooms to cozy reading corners and calm neutral spaces.
          </p>
        </div>
        <div className="flex flex-col sm:flex-row gap-4 flex-shrink-0">
          <Link
            to="/living-room"
            className="inline-flex items-center gap-2 bg-[#FAF7F0] text-[#2C2825] px-7 py-3.5 rounded-full text-xs tracking-[0.14em] hover:bg-white transition-colors duration-300 cursor-pointer whitespace-nowrap"
            style={{ fontFamily: "'Inter', sans-serif" }}
          >
            Browse Living Rooms
            <span className="w-3 h-3 flex items-center justify-center">
              <i className="ri-arrow-right-line text-[10px]" />
            </span>
          </Link>
          <Link
            to="/cozy-corners"
            className="inline-flex items-center gap-2 border border-[#6B5E53] text-[#B5A898] px-7 py-3.5 rounded-full text-xs tracking-[0.14em] hover:border-[#FAF7F0] hover:text-[#FAF7F0] transition-colors duration-300 cursor-pointer whitespace-nowrap"
            style={{ fontFamily: "'Inter', sans-serif" }}
          >
            Explore Cozy Corners
            <span className="w-3 h-3 flex items-center justify-center">
              <i className="ri-arrow-right-line text-[10px]" />
            </span>
          </Link>
        </div>
      </div>
    </section>
  );
}
